function getPaymentHistoryColumns(handlers) {
  return getColumns(handlers, paymentHistoryColumns);
}


function getMemberFeeTypeColumns(handlers) {
  return getColumns(handlers, memberFeeTypeColumns);
}


function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const paymentHistoryColumns = [
  {
    text: "결제명",
    value: "name",
    sortBy: "name",
    type: "text",
  },
  {
    text: "금액",
    value: "amount",
    sortBy: "amount",
    type: "text",
  },
  {
    text: "통화",
    value: "currency_code",
    sortBy: "currency_code",
    type: "text",
  },
  {
    text: "결제자 이메일",
    value: "payer_email",
    sortBy: "payer_email",
    type: "text",
  },
  {
    text: "승인일",
    value: "approved_at",
    type: "text",
  },
];

const memberFeeTypeColumns = [
  {
    text: "회비 구분",
    value: "name",
    sortBy: "name",
    type: "text",
  },
  {
    text: "금액(KRW)",
    value: "fee_krw",
    type: "text",
  },
  {
    text: "금액(USD)",
    value: "fee_usd",
    type: "text",
  },
  {
    text: "상세 내용",
    value: "memo",
    type: "text",
  },
];

export { getPaymentHistoryColumns, getMemberFeeTypeColumns };
